import React from 'react';
import PropTypes from 'prop-types';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';

import Button from '../../common/Button';

export function NotFoundDialog(props) {
  const { onClose } = props;

  return (
    <Dialog
      open={true}
      onClose={onClose}
    >
      <DialogTitle>
        Layer not exists
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Can't edit the selected layer. Either the layer does not exists
          in your stackup or the selected layer is not editable.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          default 
          onClick={onClose}
          type="button"
          variant="raised"
          label="Close"
        />
      </DialogActions>
    </Dialog>
  );
}

NotFoundDialog.propTypes = {
  onClose:       PropTypes.func.isRequired,
};

export default NotFoundDialog;


// WEBPACK FOOTER //
// ./src/components/StackupDesign/EditLayer/NotFoundDialog.js